<template>
  <v-layout
    row
    align-center
    :style="myLayoutStyle"
  >
    <v-flex
      xs12
      sm10
      offset-sm1
      md10
      offset-md1
      lg10
      offset-lg1
      xl8
      offset-xl2
    >
      <v-card
        flat
        :color="theme.bg_color"
      >
        <v-card-text v-if="this.status === 0">
          <h2 :style="failStyle">{{ $t('payment_fail') }}</h2>
          <v-btn
            block
            dark
            large
            class="btn"
            :color="theme.btn_color_primary"
            @click="checkout"
          >
            <v-layout row>
              <v-flex
                xs12
                class="text-xs-center"
              >
                Go back to checkout
              </v-flex>
            </v-layout>
          </v-btn>
        </v-card-text>
        <v-card-text v-else-if="this.status === 1">
          <h2 :style="successStyle">{{ $t('payment_success') }}</h2>
          <v-divider class="mt-1 mb-2" :color="theme.orders_divider_color" />
          <h4>{{ $t('staff_collect_info') }}</h4>
        </v-card-text>
        <v-card-text v-else-if="this.status === 2">
          <h2 :style="failStyle">{{ $t('payment_unknown') }}</h2>
          <v-divider class="mt-1 mb-2" />
          <h4>{{ $t('staff_check_status') }}</h4>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'payment-view',
  metaInfo () {
    return { title: this.$t('payment') }
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'restaurants', 'gid', 'rid'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    successStyle () {
      return {
        display: 'inline-block',
        lineHeight: '40px',
        color: this.theme.msg_success_color
      }
    },
    failStyle () {
      return {
        display: 'inline-block',
        lineHeight: '40px',
        color: this.theme.msg_error_color
      }
    },
    status () {
      if (this.$route.query.status) {
        return parseInt(this.$route.query.status)
      }
      return null
    }
  },
  methods: {
    checkout () {
      this.$router.push({ name: 'checkout' })
    }
  },
  created () {
    if (this.status === 1) {
      this.$store.dispatch('changeTable', '')
      // Only reset if there are multiple outlets
      // if (this.restaurants && this.restaurants.length > 1) {
      //   this.$store.dispatch('config/changeRid', 0)
      // }
      this.$store.dispatch('cart/resetCart')
      this.$store.dispatch('order/resetOrder')
    } else {
      this.$router.push({ name: 'menu', params: { gid: this.gid, rid: parseInt(this.rid) }})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/cbs.vue